import { render, staticRenderFns } from "./LoginDentalPro.vue?vue&type=template&id=687451c4&"
import script from "./LoginDentalPro.vue?vue&type=script&lang=ts&"
export * from "./LoginDentalPro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports